// Cliente para la API del Worker (/api/*). La sesión viaja en una cookie HttpOnly.
export async function api(path, {method='GET',body}={}) {
  const response=await fetch(`/api${path}`,{
    method,
    credentials: 'same-origin',
    headers: body!==undefined || method!=='GET' ? {'Content-Type': 'application/json'} : undefined,
    body: body!==undefined ? JSON.stringify(body) : method!=='GET' ? '{}' : undefined,
  });

  const data=await response.json().catch(()=> ({}));
  if (!response.ok) {
    const error=new Error(data.error || 'No se pudo conectar con el servidor');
    error.status=response.status;
    throw error;
  }
  return data;
}
